import { FileItemModel } from '@models/module/fields/main';

export interface DriveAddNewModel {
  modalType: 'rename' | 'newFile' | 'newFolder';
  parentId: number;
  name?: string;
  mimeType?: string;
  fileId?: number;
  /** Info line shown above the drop zone (e.g. the module name for Project Files). */
  information?: string;
  /** Shows the "same name → new version" checkbox and sends `isCreateVersion` on upload. */
  allowCreateVersion?: boolean;
  /** Rejects files whose mime type is not in CIPO's supported list, as legacy fmUploadController does. */
  validateMimeTypes?: boolean;
  /** `accept` attribute for the file input, narrowing what the picker offers (legacy `accept` config). */
  accept?: string;
  /**
   * Saves each note on the uploaded file itself, after the upload returns its version.
   */
  persistNotes?: boolean;
}

export interface ProjectFilesAddNewModel extends DriveAddNewModel {
  entityInstanceId?: number;
}

export interface DriveAddNewOutput {
  files?: FileItemModel[];
  name?: string;
}
